export enum DeliveryStatusEnum {
	PENDING = 'pending',
	IN_TRANSIT = 'in_transit',
	DELIVERED = 'delivered',
	FAILED = 'failed',
}

export enum CourierTypeEnum {
	PERSON = 'person',
	COMPANY = 'company',
}

export const DELIVERY_STATUS_LABELS: Record<DeliveryStatusEnum, string> = {
	[DeliveryStatusEnum.PENDING]: 'Ausstehend',
	[DeliveryStatusEnum.IN_TRANSIT]: 'Unterwegs',
	[DeliveryStatusEnum.DELIVERED]: 'Zugestellt',
	[DeliveryStatusEnum.FAILED]: 'Fehlgeschlagen',
};

export const DELIVERY_STATUS_COLORS: Record<DeliveryStatusEnum, string> = {
	[DeliveryStatusEnum.PENDING]: 'gray',
	[DeliveryStatusEnum.IN_TRANSIT]: 'yellow',
	[DeliveryStatusEnum.DELIVERED]: 'green',
	[DeliveryStatusEnum.FAILED]: 'red',
};

export interface Delivery {
	id: number;
	job_id: number;
	organization_id: string;
	status: DeliveryStatusEnum;
	courier_type: CourierTypeEnum;
	profile_id: string | null;
	courier_company_name: string | null;
	description: string | null;
	note: string | null;
	file_ids: string[];
	scheduled_departure_at: string | null;
	delivered_at: string | null;
	is_final_delivery: boolean;
	created_at: string;
	created_by: string | null;
	modified_at: string | null;
	modified_by: string | null;
}

export interface CourierDelivery {
	id: number;
	job_id: number;
	job_code: string;
	status: DeliveryStatusEnum;
	courier_type: CourierTypeEnum;
	description: string | null;
	note: string | null;
	file_ids: string[];
	scheduled_departure_at: string | null;
	delivered_at: string | null;
	created_at: string;
	lab_name: string;
	lab_street: string | null;
	lab_city: string | null;
	lab_postal_code: string | null;
	lab_country: string | null;
	client_name: string;
	client_street: string | null;
	client_city: string | null;
	client_postal_code: string | null;
	client_country: string | null;
}

export interface CreateDeliveryParams {
	job_id: number;
	courier_type: CourierTypeEnum;
	profile_id?: string;
	courier_company_name?: string;
	description?: string;
	scheduled_departure_at?: string;
	is_final_delivery?: boolean;
}
